// src/components/ScrollToTopButton.jsx
import { useEffect, useState } from 'react';
import { FiArrowUp } from 'react-icons/fi';

function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);
  const [scrollProgress, setScrollProgress] = useState(0);

  // Show button and calculate scroll progress
  useEffect(() => {
    const toggleVisibility = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;

      // Calculate scroll percentage
      const maxScroll = documentHeight - windowHeight;
      const progress = (scrollTop / maxScroll) * 100;
      setScrollProgress(progress);

      // Show button after scrolling down
      if (scrollTop > 300) {
        setVisible(true);
      } else {
        setVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);

    // Initial calculation
    toggleVisibility();

    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  // Scroll to top with smooth behavior
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    visible && (
      <div className="fixed bottom-6 right-6 z-50">
        {/* Progress Ring SVG */}
        <svg
          className="absolute top-0 left-0 w-full h-full -rotate-90"
          width="56"
          height="56"
          viewBox="0 0 56 56"
        >
          {/* Background circle */}
          <circle
            cx="28"
            cy="28"
            r="24"
            fill="none"
            style={{ stroke: 'var(--border)', strokeWidth: '2' }}
          />
          {/* Progress circle */}
          <circle
            cx="28"
            cy="28"
            r="24"
            fill="none"
            style={{
              stroke: 'var(--text)',
              strokeWidth: '2',
              strokeDasharray: '150.8',
              strokeDashoffset: `${150.8 - (scrollProgress / 100) * 150.8}`,
              transition: 'stroke-dashoffset 0.2s ease',
            }}
          />
        </svg>

        {/* Button */}
        <button
          onClick={scrollToTop}
          className="relative w-12 h-12 flex items-center justify-center rounded-full cursor-pointer transition-all duration-300 transform hover:scale-110 focus:outline-none focus:ring-2 focus:ring-offset-2"
          style={{
            backgroundColor: 'var(--text)',
            color: 'var(--bg)',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
          }}
          aria-label="Scroll to top"
        >
          <FiArrowUp className="w-5 h-5" />
        </button>
      </div>
    )
  );
}

export default ScrollToTopButton;
